module.exports = function (gsap) {
    const btns = document.querySelectorAll('div.main-footer__right-col__group__btn');
    let isMobile = null;

    fAccordion();

    for (const btn of btns) {
        btn.addEventListener('click', function () {
            if (isMobile) {
                if (btn.classList.contains('is-active')) {
                    btn.classList.remove('is-active');

                    if (btn.nextElementSibling) {
                        gsap.to(btn.nextElementSibling, {
                            height: '0'
                        })
                    }
                } else {
                    btn.classList.add('is-active');

                    if (btn.nextElementSibling) {
                        gsap.to(btn.nextElementSibling, {
                            height: 'auto'
                        })
                    }
                }
            }
        }, false)
    };

    function fAccordion() {
        if (window.innerWidth < 1200) {
            isMobile = true;

            btns.forEach((btn) => {
                btn.classList.remove('is-active');
                if (btn.nextElementSibling) {
                    gsap.to(btn.nextElementSibling, {
                        height: '0'
                    })
                }
            });

        } else {
            isMobile = false;

            btns.forEach((btn) => {
                btn.classList.remove('is-active');

                if (btn.nextElementSibling) {
                    gsap.to(btn.nextElementSibling, {
                        height: 'auto'
                    })
                }
            });
        }
    }

    window.addEventListener('resize', fAccordion);
};